/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorBinaryForGraph extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorBinaryForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorBinaryForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorBinaryForGraph>): QueryOperatorBinaryForGraph {
        let obj = Object.assign(new QueryOperatorBinaryForGraph(), model);
        QueryOperatorBinaryForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorBinaryForGraph>): QueryOperatorBinaryForGraph {
        if (!model) return null;
        return QueryOperatorBinaryForGraph.newInstance(<QueryOperatorBinaryForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorBinaryForGraph) {
        if (!obj) return;

        models.QueryOperatorBinaryForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorBinaryForGraph): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorBinaryForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.a) {
            models.QueryOperator.fixupPrototype(this.a);
        }
        if (this.b) {
            models.QueryOperator.fixupPrototype(this.b);
        }
    }

    /**
     * Left side of binary query operator
     */
    a: models.QueryOperator;

    /**
     * Right side of binary query operator
     */
    b: models.QueryOperator;

}
